import React, { ReactNode, useEffect, useState } from 'react';
import Sidebar from './Sidebar';
import MainContent from './MainContent';
import styles from '../../styles/layout/EnterpriseLayout.module.scss';
import clsx from 'clsx';

interface EnterpriseLayoutProps {
  pageTitle: string;
  pageDescription?: string;
  pageActions?: ReactNode;
  pageBodyClassName?: string;
  children: ReactNode;
}

function EnterpriseLayout({ pageTitle, pageDescription, pageActions, pageBodyClassName, children }: EnterpriseLayoutProps) {
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);
  const [isMobileSidebarOpen, setIsMobileSidebarOpen] = useState(false);

  const handleToggleSidebar = () => {
    setIsSidebarCollapsed(!isSidebarCollapsed);
  };

  const handleToggleMobileSidebar = () => {
    setIsMobileSidebarOpen(!isMobileSidebarOpen);
  };

  const handleCloseMobileSidebar = () => {
    setIsMobileSidebarOpen(false);
  };

  useEffect(() => {
    if (pageBodyClassName) {
      const bodyClasses = pageBodyClassName.split(' ').filter(Boolean);
      bodyClasses.forEach(cls => document.body.classList.add(cls));

      return () => {
        bodyClasses.forEach(cls => document.body.classList.remove(cls));
      };
    }
  }, [pageBodyClassName]);

  useEffect(() => {
    // Add enterprise layout class to body
    document.body.classList.add('enterprise-layout');
    return () => {
      document.body.classList.remove('enterprise-layout');
    };
  }, []);

  return (
    <>
      <title>{`Liquid Credit | ${pageTitle}`}</title>
      <div className={clsx(styles.enterpriseLayout, 'enterprise-layout')}>
        <Sidebar
          isCollapsed={isSidebarCollapsed}
          isMobileOpen={isMobileSidebarOpen}
          onToggleCollapse={handleToggleSidebar}
          onToggleMobile={handleToggleMobileSidebar}
          onCloseMobile={handleCloseMobileSidebar}
        />
        
        <MainContent
          pageTitle={pageTitle}
          pageDescription={pageDescription}
          pageActions={pageActions}
          isSidebarCollapsed={isSidebarCollapsed}
          onToggleMobileSidebar={handleToggleMobileSidebar}
        >
          {children}
        </MainContent>

        {/* Mobile overlay */}
        {isMobileSidebarOpen && (
          <div 
            className={styles.mobileOverlay}
            onClick={handleCloseMobileSidebar}
          />
        )}
      </div>
    </>
  );
}

export default EnterpriseLayout;
